import React, { useState, useEffect, useRef } from 'react'; 
import styles from './styles/ClassroomAssignmentsFilter.module.css';
import { FaFilter, FaTimes, FaCalendarAlt } from 'react-icons/fa'; 

const ClassroomAssignmentsFilter = ({ filter, onApply, onClose }) => {
    
    const [dateType, setDateType] = useState('createdAt');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const modalRef = useRef(null); 

    
    useEffect(() => {
        if (filter) {
            setDateType(filter.dateType);
            
            setStartDate(filter.startDate ? new Date(filter.startDate).toISOString().split('T')[0] : '');
            setEndDate(filter.endDate ? new Date(filter.endDate).toISOString().split('T')[0] : '');
        } else {
            
            setDateType('createdAt');
            setStartDate('');
            setEndDate('');
        }
    }, [filter]);

    
    const handleSubmit = (e) => {
        e.preventDefault();
        
        if (startDate && endDate && new Date(endDate) < new Date(startDate)) {
            alert("End date cannot be earlier than start date.");
            return;
        }
        onApply({ dateType, startDate, endDate });
    };

    
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                
                if (event.target.classList.contains(styles.modalOverlay)) {
                     onClose();
                }
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClose]);

     
    useEffect(() => {
        const handleEsc = (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };
        document.addEventListener('keydown', handleEsc);
        return () => {
            document.removeEventListener('keydown', handleEsc);
        };
    }, [onClose]);


    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalContent} ref={modalRef} role="dialog" aria-modal="true" aria-labelledby="filterModalTitle">
                 <h2 id="filterModalTitle" className={styles.modalTitle}>
                    <FaFilter /> Filter Assignments by Date
                </h2>

                <form onSubmit={handleSubmit} className={styles.filterForm}>
                    {/* Date Type Selection */}
                    <fieldset className={styles.fieldset}>
                        <legend className={styles.legend}>Filter based on:</legend>
                        <div className={styles.radioGroup}>
                            <label className={styles.radioLabel}>
                                <input
                                    type="radio"
                                    name="dateType"
                                    value="createdAt"
                                    checked={dateType === 'createdAt'}
                                    onChange={() => setDateType('createdAt')}
                                    className={styles.radioInput}
                                />
                                <span className={styles.radioText}>Assigned Date</span>
                            </label>
                            <label className={styles.radioLabel}>
                                <input
                                    type="radio"
                                    name="dateType"
                                    value="dueDate"
                                    checked={dateType === 'dueDate'}
                                    onChange={() => setDateType('dueDate')}
                                    className={styles.radioInput}
                                />
                                <span className={styles.radioText}>Due Date</span>
                            </label>
                        </div>
                    </fieldset>

                    {/* Date Range Selection */}
                     <fieldset className={styles.fieldset}>
                        <legend className={styles.legend}>Select date range:</legend>
                         <div className={styles.dateInputsGroup}>
                            <div className={styles.inputGroup}>
                                <label htmlFor="startDateInput" className={styles.label}>
                                    Start Date <span className={styles.requiredIndicator}>*</span>
                                </label>
                                <div className={styles.dateInputWrapper}>
                                    <FaCalendarAlt className={styles.dateInputIcon}/>
                                    <input
                                        id="startDateInput"
                                        type="date"
                                        value={startDate}
                                        onChange={(e) => setStartDate(e.target.value)}
                                        className={styles.inputField} 
                                        required
                                        aria-required="true"
                                    />
                                </div>
                            </div>
                            <div className={styles.inputGroup}>
                                <label htmlFor="endDateInput" className={styles.label}>
                                    End Date <span className={styles.requiredIndicator}>*</span>
                                </label>
                                 <div className={styles.dateInputWrapper}>
                                     <FaCalendarAlt className={styles.dateInputIcon}/>
                                    <input
                                        id="endDateInput"
                                        type="date"
                                        value={endDate}
                                        onChange={(e) => setEndDate(e.target.value)}
                                        className={styles.inputField} 
                                        required
                                        aria-required="true"
                                        min={startDate} 
                                    />
                                </div>
                            </div>
                        </div>
                    </fieldset>

                    {/* Action Buttons */}
                    <div className={styles.buttonGroup}>
                        <button type="submit" className={`${styles.button} ${styles.buttonPrimary}`} disabled={!startDate || !endDate}>
                            Apply Filter
                        </button>
                        <button type="button" className={`${styles.button} ${styles.buttonSecondary}`} onClick={onClose}>
                            <FaTimes /> Cancel
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ClassroomAssignmentsFilter;